import React from "react";
import Explainer from "../ExplainerModal";

const TasksExplainer = () => {
  return (
    <Explainer
      title="My Tasks Explainer"
      content={
        <>
          <p>
            The <strong>Tasks Panel</strong> provides an organized view of assigned tasks, categorized into three key areas:
          </p>
         <ul>
              <li>🗂️ <strong>ETracker</strong> – Tasks related to policy milestones from initiation to development stages.</li>
              <li>📊 <strong>Benchmarking</strong> – Tasks concerning data collection and validation for benchmarking.</li>
              <li>🌍 <strong>Landscaping</strong> – Tasks focused on policy landscaping and focal area assessments.</li>
         </ul>
          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>🔹 Task Assignment Based on User Roles:</h3>
          <ul>
            <li>✅ <strong>Owners:</strong> Tasks appear if milestones for ETracker or Benchmarking are incomplete. Once completed, they are removed.</li>
            <li>✅ <strong>Supervisors:</strong> Tasks appear when awaiting approval. Once approved, they disappear.</li>
            <li>✅ <strong>General Users:</strong> If not an owner or supervisor, a message will be displayed: <em>“No tasks available.”</em></li>
          </ul>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>📌 Reviewing Completed Tasks:</h3>
          <p>If you have completed a task but need to review it again:</p>
          <ul>
            <li>📍 <strong>ETracker:</strong> Navigate to <strong>Policy Directory</strong>, find the policy, and locate the milestone.</li>
            <li>📍 <strong>Benchmarking:</strong> Go to <strong>Benchmarking Page</strong>, then <strong>Data</strong>, and find the specific milestone.</li>
            <li>📍 <strong>Landscaping:</strong> Navigate to <strong>Policy Landscaping</strong>, then <strong>Data</strong>, and locate the relevant <strong>focal area</strong>.</li>
          </ul>
        </>
      }
    />
  );
};

export default TasksExplainer;
